import { NumericFormat, NumericFormatProps } from "react-number-format";
import React from "react";

interface CustomProps {
  name: string;
  onChange: (event: { target: { name: string; value: null | number | string } }) => void;
  stringify: boolean;
}

export const NumberFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(function NumberFormatCustom(
  { name, onChange, stringify, ...other },
  ref
) {
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={({ value, floatValue }) => {
        onChange({ target: { name, value: stringify ? value : floatValue ?? null } });
      }}
    />
  );
});
